import { Question } from "models/questionnaire.model";
import { textOutline, listCircleOutline, pricetagOutline, checkboxOutline, caretDownCircleOutline, calendarOutline, timeOutline, documentTextOutline, leafOutline, listOutline, alertOutline, gridOutline, pencilOutline } from "ionicons/icons";
import { UIElementEnum } from "models/ui-element.enum";
export * from "./domain";
export * from "./storageLoginInfo";

const listElements = [UIElementEnum.dd, UIElementEnum.ms, UIElementEnum.multi, UIElementEnum.rb, UIElementEnum.rbBlock, UIElementEnum.rbil];
const icons: any = {
    [UIElementEnum.cb]: checkboxOutline,
    [UIElementEnum.pa]: documentTextOutline,
    [UIElementEnum.ta]: textOutline,
    [UIElementEnum.tb]: textOutline,
    [UIElementEnum.date]: calendarOutline,
    [UIElementEnum.datetime]: timeOutline,
    [UIElementEnum.lb]: pricetagOutline,
    [UIElementEnum.ph]: gridOutline,
    [UIElementEnum.sig]: pencilOutline
};

export const getIcon = (uiType: string): string => {
    const enumType = UIElementEnum[uiType as keyof typeof UIElementEnum];
    if(listElements.includes(enumType)) return listOutline

    return icons[enumType] || alertOutline;
}

export const getIconById = (uiElementId: number): string => {
    if (uiElementId === UIElementEnum.unknown) return leafOutline;
    if (listElements.includes(uiElementId)) return listOutline;

    return icons[uiElementId] || alertOutline;
}

export const createCustomItems = () => {
    return [
        {
            Label: 'Yes/No',
            UIControlType: UIElementEnum.rbil,
            Icon: listCircleOutline
        },
        {
            Label: 'Multiple Question',
            UIControlType: UIElementEnum.rbil,
            Icon: listCircleOutline
        },
        {
            Label: 'Text Box',
            UIControlType: UIElementEnum.tb,
            Icon: textOutline
        },
        {
            Label: 'Text Area',
            UIControlType: UIElementEnum.ta,
            Icon: textOutline
        },
        {
            Label: 'Label',
            UIControlType: UIElementEnum.lb,
            Icon: pricetagOutline
        },
        {
            Label: 'Checkbox',
            UIControlType: UIElementEnum.cb,
            Icon: checkboxOutline
        },
        {
            Label: 'Dropdown',
            UIControlType: UIElementEnum.dd,
            Icon: caretDownCircleOutline
        },
        {
            Label: 'Date',
            UIControlType: UIElementEnum.date,
            Icon: calendarOutline
        },
        {
            Label: 'Date Time',
            UIControlType: UIElementEnum.datetime,
            Icon: timeOutline
        },
        {
            Label: 'Paragraph',
            UIControlType: UIElementEnum.pa,
            Icon: documentTextOutline
        },
        {
            Label: 'Placeholder',
            UIControlType: UIElementEnum.ph,
            Icon: gridOutline
        },
        {
            Label: 'Signature',
            UIControlType: UIElementEnum.sig,
            Icon: pencilOutline
        },
        {
            Label: 'Multiselect Question',
            UIControlType: UIElementEnum.multi,
            Icon: caretDownCircleOutline
        }
    ] as Array<Partial<Question>>;
}